<template>
  <div class="visit-register">
    <div class="visit-register-header">
      <div class="logo-2">
        <img src="@/assets/images/logo-lg.svg" alt="-visipoint-logo" />
      </div>
      <p class="form-title">
        {{
          this.$route.query.add_visitor
            ? $t('preRegisteration.confirm_visit_invitation')
            : $t('common.welcome')
        }}
      </p>
      <div class="login-container">
        <p class="sub-title" v-if="!this.$route.query.add_visitor">
          {{ $t('common.hasPassport') }} {{ $t('common.?') }} &nbsp;   
        </p>

        <router-link
            v-if="!$route.query.add_visitor"
            :to="{
              name: 'passport',
              query: {
                redirect_url: this.$router.currentRoute.path,
                visit_date: this.formatedVisitDate ? this.formatedVisitDate : '',
                visit_time: this.formattedTime ? this.formattedTime : '',
                area_id: this.getSelectedArea ? this.getSelectedArea.id : '',
                registration_method: this.getSelectedUserType
                  ? this.getSelectedUserType[0].pre_registration_method
                  : '',
                entity_id: this.getSelectedUserType
                  ? this.getSelectedUserType[0].entity_id
                  : '',
                user_type_id: this.getSelectedUserType
                  ? this.getSelectedUserType[0].id
                  : '',
                journey_flow_id: getJourneyFlowId,
                email: this.form.email,
                phone: this.form.phone,
              },
            }"
            class="login-btn"
          >
           {{ $t('common.login').toUpperCase() }}</router-link
          >
    </div>
    </div>
    <div class="content">
      <b-form @submit.prevent="onSubmit" novalidate>
        <div class="row-group first-last-name-wrapper">
          <!-- first name  -->
          <div class="first-name">
            <div
              class="form-group m-d-gruop"
              :class="$v.form.first_name.$error && 'invalid-value'"
            >
              <div class="required-star">
                <span class="required">*</span>
              </div>
              <input
                v-model="form.first_name"
                type="text"
                class="form-control"
                :class="{
                  'not-allowed-cursor':
                    form.first_name && form.first_name.length >= 20,
                }"
                id="first_name"
                required
                maxlength="20"
              />
              <label for="first_name">{{ $t('common.firstName') }}</label>
            </div>
            <div class="err-wrapperr">
              <div v-if="submitted && !$v.form.first_name.required">
                <span class="errorr-value">First name is required</span>
              </div>
              <div v-if="submitted && !$v.form.first_name.maxLength">
                <span class="errorr-value"
                  >{{ $t('common.validation.maximumLength20Characters') }}.</span
                >
              </div>
            </div>
          </div>
          <!-- last name  -->
          <div class="last-name">
            <div
              class="form-group m-d-gruop"
              :class="$v.form.last_name.$error && 'invalid-value'"
            >
              <div class="required-star">
                <span class="required">*</span>
              </div>
              <b-form-input
                id="last_name"
                v-model.trim="form.last_name"
                :class="{
                  'not-allowed-cursor':
                    form.last_name && form.last_name.length >= 20,
                }"
                type="text"
                required
                maxlength="20"
              />
              <label for="last_name">{{ $t('common.lastName') }}</label>
            </div>
            <div class="err-wrapperr">
              <div v-if="submitted && !$v.form.last_name.required">
                <span class="errorr-value">Last name is required.</span>
              </div>
              <div v-if="submitted && !$v.form.last_name.maxLength">
                <span class="errorr-value"
                  >{{ $t('common.validation.maximumLength20Characters') }}.</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="register-email-phone" v-if="form.register_check">
          <div class="register-hint">
            <hr class="h-line" />
            <p class="hint-label">{{ $t('common.notes.addEmailOrPhone') }}</p>
          </div>

          <!-- email   -->
          <div class="email-wrapper">
            <div
              class="form-group m-d-gruop"
              :class="emailDuplicated && 'invalid-value'"
            >
              <b-form-input
                id="email"
                v-model.trim="form.email"
                type="text"
                required
                class="form-control"
                @input="
                  $v.form.email.$touch();
                  emailDuplicated = false;
                "
                @keypress="onEmailTyping"
                @paste="onEmailTyping"
                :disabled="this.$route.query.add_visitor && !!originalEmail"
              />
              <label
                for="email"
                :class="{
                  'disable-label':
                    this.$route.query.add_visitor && !!originalEmail,
                }"
                >{{ $t('common.email')}}</label
              >
            </div>
            <div class="err-wrapper">
              <div v-if="submitted && emailDuplicated">
                <span class="error-value">
                  {{ $t('common.notes.emailAddressAlreadyExists') }}
                </span>
              </div>
              <div
                v-if="
                  email_typing &&
                  form.email &&
                  getEmailDuplicatedCheck &&
                  getEmailDuplicatedCheck.msg.length > 0
                "
              >
                <span class="error-value"
                  >{{ $t('preRegisteration.deactivated_account_email') }}
                  <router-link tag="a" to="/login" class="login-btn"
                    >{{ $t('common.login').toUpperCase() }}</router-link
                  ></span
                >
              </div>
            </div>
          </div>
          <!-- phone  -->
          <div class="input-wrapper current-phone">
            <div class="row-group phone-group justify-content-start">
              <VueCountryCode
                v-if="
                  !this.$route.query.add_visitor ||
                  changePhone ||
                  !originalPhoneInput
                "
                class="country-code-input"
                :disabledFetchingCountry="false"
                @onSelect="onSelectUserCountryCode"
                :enabledCountryCode="true"
                :preferredCountries="['GB', 'US', 'CN']"
                :class="phoneDuplicated && 'invalid-value'"
              />
              <div
                class="form-group m-d-gruop w-100 mb-0"
                :class="phoneDuplicated && 'invalid-value'"
              >
                <b-form-input
                  id="phone"
                  class="input-hide-arrow"
                  v-model.trim="phone_input"
                  type="number"
                  required
                  @input="
                    $v.phone_input.$touch();
                    phoneDuplicated = false;
                  "
                  @keypress="onPhoneInputTyping"
                  :disabled="
                    this.$route.query.add_visitor &&
                    !!originalPhoneInput &&
                    !changePhone
                  "
                />
                <label
                  for="phone"
                  :class="{
                    'disable-label':
                      this.$route.query.add_visitor &&
                      !!originalPhoneInput &&
                      !changePhone,
                  }"
                  >{{ $t('common.phoneNumber') }}</label
                >
              </div>
              <a
                v-if="
                  this.$route.query.add_visitor &&
                  originalPhoneInput &&
                  !changePhone &&
                  originalEmail
                "
                @click="
                  phone_input = '';
                  changePhone = true;
                "
                class="change-text ml-2"
                >{{ $t('common.change') }}</a
              >
            </div>
            <div class="err-wrapper">
              <div v-if="submitted && phoneDuplicated">
                <span class="error-value">
                  {{$t('common.notes.phoneNumberAlreadyExists')}}
                </span>
              </div>
              <div
                v-if="
                  phoneInputTyping &&
                  phone_input &&
                  getPhoneDuplicatedCheck &&
                  getPhoneDuplicatedCheck.msg.length > 0
                "
              >
                <span class="error-value"
                  >{{ $t('preRegisteration.deactivated_account_phone') }}
                  <router-link tag="a" to="/login" class="redirect-login"
                    >{{ $t('common.login').toUpperCase() }}</router-link
                  ></span
                >
              </div>
              <div v-else-if="submitted && !$v.phone_input.numeric">
                <span class="error-value">
                  {{ $t('common.notes.phoneNumberOnlyDigits') }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="passport-email-phone" v-else>
          <!-- email   -->
          <div class="email-wrapper">
            <div
              class="form-group m-d-gruop"
              :class="
                ($v.form.email.$error || emailDuplicated) && 'invalid-value'
              "
            >
              <b-form-input
                id="email"
                v-model.trim="form.email"
                type="text"
                required
                class="form-control"
                @input="
                  $v.form.email.$touch();
                  emailDuplicated = false;
                "
                :disabled="this.$route.query.add_visitor && !!originalEmail"
              />
              <label
                for="email"
                :class="{
                  'disable-label':
                    this.$route.query.add_visitor && !!originalEmail,
                }"
                >{{ $t('common.email')}}</label
              >
            </div>

            <div class="err-wrapper">
              <div v-if="submitted && emailDuplicated">
                <span class="error-value">
                  {{ $t('common.notes.emailAddressAlreadyExists') }}
                </span>
              </div>
              <div v-if="$v.form.email.$error" class="error-value" style="text-align: -webkit-auto; padding: unset;">
                {{ $t('common.notes.enterValidEmailMessage') }}.
                <!-- <span class="error-value" 
                  >{{ $t('common.notes.enterValidEmailMessage') }}.</span
                > -->
              </div>
            </div>
          </div>
          <!-- phone  -->
          <div class="input-wrapper current-phone">
            <div class="row-group phone-group justify-content-start">
              <VueCountryCode
                v-if="
                  !this.$route.query.add_visitor ||
                  changePhone ||
                  !originalPhoneInput
                "
                class="country-code-input"
                :disabledFetchingCountry="false"
                @onSelect="onSelectUserCountryCode"
                :enabledCountryCode="true"
                :preferredCountries="['GB', 'US', 'CN']"
                :class="phoneDuplicated && 'invalid-value'"
              />
              <div
                class="form-group m-d-gruop w-100 mb-0"
                :class="phoneDuplicated && 'invalid-value'"
              >
                <b-form-input
                  class="input-hide-arrow"
                  id="phone"
                  v-model.trim="phone_input"
                  type="number"
                  required
                  @input="
                    $v.phone_input.$touch();
                    phoneDuplicated = false;
                  "
                  :disabled="
                    this.$route.query.add_visitor &&
                    !!originalPhoneInput &&
                    !changePhone
                  "
                />
                <label
                  for="phone"
                  :class="{
                    'disable-label':
                      this.$route.query.add_visitor &&
                      !!originalPhoneInput &&
                      !changePhone,
                  }"
                  >{{ $t('common.phoneNumber') }}</label
                >
              </div>
              <a
                v-if="
                  this.$route.query.add_visitor &&
                  originalPhoneInput &&
                  !changePhone &&
                  originalEmail
                "
                @click="
                  phone_input = '';
                  changePhone = true;
                "
                class="change-text ml-2"
                >{{ $t('common.change') }}</a
              >
            </div>
            <div class="err-wrapper">
              <div v-if="submitted && !$v.phone_input.numeric">
                <span class="error-value">
                  {{ $t('common.notes.phoneNumberOnlyDigits') }}
                </span>
              </div>

              <div v-if="submitted && phoneDuplicated">
                <span class="error-value">
                  {{$t('common.notes.phoneNumberAlreadyExists')}}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- register account check  -->
        <div
          id="customized-check"
          class="register-account-check-wrapper register-checkbox"
        >
          <b-form-checkbox
            class="custom-checkbox-dark custom-checkbox"
            v-model="form.register_check"
          >
          </b-form-checkbox>
          <p class="text">
            {{ $t('common.notes.preRegisterationNote') }}
          </p>
        </div>
        <b-button
          variant="primary"
          :disabled="
            disableSubmitBtn ||
            isLoading ||
            $v.form.email.$error ||
            emailDuplicated ||
            phoneDuplicated
          "
          class="generate-btn activ-btn"
          @click="handelRegister"
        >
          <i
            v-if="isLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          <span>{{
            this.$route.query.add_visitor
              ?
              ((getPreRegistrationData?.user.image &&
                    getCompliance.is_image_required) ||
                    !getCompliance.is_image_required) &&
                  !getSections.length
                ? $t('common.confirm')
                : $t('common.next')
              : $t('common.register')
          }}</span>
        </b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  numeric,
  required,
  email,
  maxLength,
  requiredIf,
} from "vuelidate/lib/validators";
import VueCountryCode from "vue-country-code";
import usersService from "@/services/users";
import moment from "moment";

export default {
  components: { VueCountryCode },
  props: {
    sectionPayload: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      changePhone: false,
      originalPhoneInput: "",
      originalEmail: "",
      emailDuplicated: null,
      phoneDuplicated: null,
      isLoading: false,
      area_id: null,
      location: window.location.href,
      form: {
        first_name: null,
        last_name: null,
        email: null,
        company_name: null,
        phone: null,
        register_check: false,
      },
      submitted: false,
      email_typing: false,
      phoneInputTyping: false,
      phone_input: "",
      userCountryCode: null,
    };
  },
  watch: {
    phone_input(phone_input) {
      console.log("phone", phone_input);
      if (this.$route.query.add_visitor) {
        if (this.phone_input == this.getPhoneInput) {
          this.form.phone = `${phone_input}`;
        } else {
          this.form.phone = phone_input
            ? `${this.userCountryCode}${phone_input}`
            : "";
        }
      } else {
        this.selectPhoneInput(
          phone_input && phone_input?.length > 0 ? phone_input : null
        );
        if (phone_input && phone_input?.length > 0) {
          this.form.phone = `${this.userCountryCode}${phone_input}`;
        } else {
          this.form.phone = null;
        }
      }
    },

    userCountryCode(user_country_code) {
      this.selectUserCountryCode(user_country_code);
      if (this.phone_input && this.phone_input.length > 0) {
        this.form.phone = `${user_country_code}${this.phone_input}`;
      } else {
        this.form.phone = null;
      }
    },
  },
  validations: {
    form: {
      first_name: {
        required,
        maxLength: maxLength(20),
      },
      last_name: {
        required,
        maxLength: maxLength(20),
      },
      // company_name: {
      //   maxLength: maxLength(30),
      // },
      email: {
        email,
        required: requiredIf(function () {
          const {
            form: { register_check },
            phone_input,
          } = this;
          return register_check && !phone_input;
        }),
      },
    },
    phone_input: {
      required: requiredIf(function () {
        const {
          form: { email, register_check },
        } = this;
        return register_check && !email;
      }),
      numeric,
      maxLength: maxLength(30),
    },
  },
  methods: {
    ...mapActions("i18N",["setLanguageAction"]),
    ...mapActions("authfack", [
      "checkDuplicated",
      "checkDuplicatedForConfirm",
      "registeruser",
    ]),
    ...mapActions("preRegistration", [
      "selectRedirectLoader",
      "selectUserType",
      "selectFirstName",
      "selectLastName",
      "selectEmail",
      "selectCompanyName",
      "selectPhone",
      "selectPhoneInput",
      "selectUserCountryCode",
      "selectRegistrationCheck",
      "preRegRegisterUserService",
      "setHasFilledForm",
      "getValidateUserType",
      "checkUserEntity",
      "checkVisitExists",
      "setRegisterPassportAcc",
      "setCommingFromLogin",
      "setPassportUser",
      "selectUserEntity",
      "getPreRegDetails",
      "confirmExpectedVisit",
      "checkDuplicatedForConfirmCloud",
      "setSections",
    ]),
    async handelRegister() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isLoading = true;
      this.emailDuplicated = this.phoneDuplicated = false;
      this.$emit("getFormData", this.form);
      this.setHasFilledForm(true);

      let userExists = 1;

      if (this.form.email && !this.$route.query.add_visitor) {
        const res = await this.checkDuplicated({
          field: "email",
          value: this.form.email,
        });
        if (!res.data.data.available) {
          this.isLoading = false;
          return;
        }
      } else if (this.form.email && this.$route.query.add_visitor) {
        // check if email exists in users list (cloud)
        await this.checkDuplicatedForConfirmCloud({
          entity_id: this.getPreRegistrationData.entity.id,
          field: "email",
          value: this.form.email,
          user_id: this.getPreRegistrationData.user.user_id,
        }).then(async (data) => {
          if (!data.data.data.available) {
            this.emailDuplicated = true;
            this.isLoading = false;
            return;
          } else {
            // check if email has passport
            await this.checkDuplicatedForConfirm({
              field: "email",
              value: this.form.email,
            })
              .then((res) => {
                if (!res.data.data.available) {
                  console.log(
                    "passport email exists",
                    this.getEmailDuplicatedCheck
                  );
                  this.isLoading = false;
                  return;
                }
              })
              .catch((err) => {
                console.log(err);
                this.isLoading = false;
                return;
              });
          }
        });
      }

      if (this.form.phone && !this.$route.query.add_visitor) {
        const res = await this.checkDuplicated({
          field: "phone",
          value: this.form.phone,
        });
        if (!res.data.data.available) {
          this.isLoading = false;
          return;
        }
      } else if (this.form.phone && this.$route.query.add_visitor) {
        // check if phone exists in user's list (cloud)
        await this.checkDuplicatedForConfirmCloud({
          entity_id: this.getPreRegistrationData.entity.id,
          field: "phone",
          value: this.form.phone,
          user_id: this.getPreRegistrationData.user.user_id,
        }).then(async (data) => {
          if (!data.data.data.available) {
            this.phoneDuplicated = true;
            this.isLoading = false;
            return;
          } else {
            // check if phone has passport
            await this.checkDuplicatedForConfirm({
              field: "phone",
              value: this.form.phone,
            })
              .then((res) => {
                if (!res.data.data.available) {
                  // this.phoneDuplicated = true;
                  this.isLoading = false;
                  return;
                }
              })
              .catch((err) => {
                console.log("errrrr phone", err);
                this.isLoading = false;
                return;
              });
          }
        });
      }

      if (this.isLoading) {
        let sections;
        if (!this.$route.query.add_visitor) {
          if (this.form.phone || this.form.email) {
            // If either email or phone input is provided, check if the user exists
            const response = await usersService.checkIfUserExists(
              this.form.email,
              this.phone_input
            );
            const { data } = response; // Destructure data from the response
            userExists = !data; // Set userExists based on whether data is found
          }

          // Prepare payload for checking custom fields API
          const checkCustomFieldsApiPayload = {
            ...this.sectionPayload,
            phone: this.phone_input ? encodeURIComponent(this.phone_input) : "",
            email: this.form.email ? encodeURIComponent(this.form.email) : "",
            visit_date: moment(new Date(this.getVisitDate)).format(
              "YYYY-MM-DD"
            ),
            visit_time: moment(this.getVisitTime).format("HH:mm:ss"),
            user_type_id: this.getSelectedUserType[0].id,
            is_new_user: userExists ? 1 : 0,
          };

          // Fetch expected visit custom fields
          const { data: allSections } =
            await usersService.getExpectedVisitCustomFields(
              checkCustomFieldsApiPayload
            );

          // Update sections and emit 'next' event
          this.setSections(allSections);
          sections = allSections;
          this.$emit("updateShowSections", !!sections.length);

          await new Promise((resolve) =>
            setTimeout(() => {
              resolve();
            }, 100)
          );
        }
        this.selectFirstName(this.form.first_name);
        this.selectLastName(this.form.last_name);
        this.selectEmail(this.form.email);
        // this.selectCompanyName(this.form.company_name);
        this.setRegisterPassportAcc(this.form.register_check);
        this.setCommingFromLogin(false);
        if (this.form.phone) {
          this.selectPhone(`${this.form.phone}`);
        } else {
          this.selectPhone(null);
        }

        if (this.form.register_check) {
          this.preRegRegisterUserService({
            first_name: this.form.first_name,
            last_name: this.form.last_name,
            company_name: "",
            email: this.form.email,
            phone: this.form.phone,
          })
            .then(() => {
              if (!this.$route.query.add_visitor) {
                this.getValidateUserType({
                  key: this.form.email ? "email" : "phone",
                  value: this.form.email ? this.form.email : this.form.phone,
                  entity_id: this.getSelectedUserType[0].entity_id,
                }).then(() => {
                  // this.isLoading = true;
                  setTimeout(() => {
                    console.log(
                      "getNotAllowedToRegister",
                      this.getNotAllowedToRegister
                    );
                    if (this.getNotAllowedToRegister) {
                      this.isLoading = false;
                      this.$emit("next", this.form.register_check);
                    } else {
                      this.checkVisitExists({
                        data: this.$route.query,
                      }).then(() => {
                        setTimeout(() => {
                          if (this.getVisitExists) {
                            this.isLoading = false;
                            console.log("visitExists", this.getVisitExists);
                            this.$emit("next", this.form.register_check);
                          } else {
                            const obj = {
                              passport_id: null,
                              entity_id: this.getSelectedUserType[0].entity_id,
                            };
                            if (this.form.email) {
                              obj.email = this.form.email;
                            }
                            if (this.form.phone) {
                              obj.phone = this.form.phone;
                            }
                            this.checkUserEntity(obj).then(() => {
                              this.isLoading = true;
                              setTimeout(async () => {
                                if (this.getDifferentUserType) {
                                  console.log(
                                    "difff",
                                    this.getDifferentUserType
                                  );
                                  this.$emit("next", this.form.register_check);
                                } else if (
                                  ((this.getUserEntity?.image &&
                                    this.getCompliance.is_image_required) ||
                                    !this.getCompliance?.is_image_required) &&
                                  (!this.getTouchModeStatus ||
                                    !this.getHostUserTypesExist) &&
                                  !sections.length
                                ) {
                                  // setTimeout(() => {
                                  this.$emit(
                                    "finish",
                                    this.form.register_check
                                  );
                                  // }, 3000);
                                } else {
                                  this.$emit("next", this.form.register_check);
                                }
                                this.isLoading = false;
                              }, 3000);
                            });
                          }
                        }, 3000);
                      });
                    }
                  }, 2000);
                });
              } else {
                console.log("confirmmmm");
                this.isLoading = false;
                if (
                  ((this.getPreRegistrationData?.user.image &&
                    this.getCompliance.is_image_required) ||
                    !this.getCompliance.is_image_required) &&
                  !this.getSections.length
                ) {
                  this.confirmExpectedVisit();
                } else {
                  console.log("else");
                  this.$emit("next", this.form.register_check);
                }
              }
            })
            .catch(() => {
              this.isLoading = false;
            });
        } else if (
          !this.form.register_check
          // &&
          // (this.getEmailDuplicatedCheck?.available ||
          //   this.getPhoneDuplicatedCheck?.available ||
          //   (!this.form.email && !this.form.phone))
        ) {
          this.setPassportUser(null);
          if (!this.$route.query.add_visitor) {
            if (this.form.email || this.form.phone) {
              this.getValidateUserType({
                key: this.form.email ? "email" : "phone",
                value: this.form.email ? this.form.email : this.form.phone,
                entity_id: this.getSelectedUserType[0].entity_id,
              }).then(() => {
                this.isLoading = true;
                setTimeout(() => {
                  // console.log(
                  //   "getNotAllowedToRegister",
                  //   this.getNotAllowedToRegister
                  // );
                  if (this.getNotAllowedToRegister) {
                    this.isLoading = false;
                    this.$emit("next", this.form.register_check);
                  } else {
                    this.checkVisitExists({
                      data: this.$route.query,
                    }).then(() => {
                      setTimeout(() => {
                        console.log(
                          "visitExists beforeee",
                          this.getVisitExists
                        );
                        if (this.getVisitExists) {
                          this.isLoading = false;
                          console.log("visitExists nocjk", this.getVisitExists);
                          this.$emit("next", this.form.register_check);
                        } else {
                          const obj = {
                            passport_id: null,
                            entity_id: this.getSelectedUserType[0].entity_id,
                          };
                          if (this.form.email) {
                            obj.email = this.form.email;
                          }
                          if (this.form.phone) {
                            obj.phone = this.form.phone;
                          }
                          this.checkUserEntity(obj).then(() => {
                            this.isLoading = true;
                            setTimeout(async () => {
                              this.isLoading = false;
                              if (this.getDifferentUserType) {
                                // console.log("difff 2", this.getDifferentUserType);
                                this.$emit("next", this.form.register_check);
                              } else if (
                                (this.getUserEntity?.image &&
                                  this.getCompliance.is_image_required) ||
                                (!this.getCompliance?.is_image_required &&
                                  (!this.getTouchModeStatus ||
                                    !this.getHostUserTypesExist) &&
                                  !sections.length)
                              ) {
                                // setTimeout(() => {
                                this.$emit("finish", this.form.register_check);
                                // }, 3000);
                              } else {
                                this.$emit("next", this.form.register_check);
                              }
                            }, 2000);
                          });
                        }
                      }, 3000);
                    });
                  }
                }, 2000);
              });
            } else if (
              this.getCompliance?.is_image_required ||
              (this.getTouchModeStatus && this.getHostUserTypesExist) ||
              sections.length
            ) {
              this.selectUserEntity(null);
              this.$emit("next", this.form.register_check);
            } else {
              this.$emit("finish", this.form.register_check);
            }
          } else {
            console.log("not check confirmmmm");
            this.isLoading = false;
            if (
              ((this.getPreRegistrationData?.user.image &&
                this.getCompliance.is_image_required) ||
                !this.getCompliance.is_image_required) &&
              !this.getSections.length
            ) {
              this.confirmExpectedVisit();
            } else {
              console.log("else");
              this.$emit("next", this.form.register_check);
            }
          }
        }
      }
    },
    onPhoneInputTyping() {
      this.phoneInputTyping = true;
    },
    onEmailTyping() {
      this.email_typing = true;
    },
    onSelectUserCountryCode({ dialCode }) {
      this.userCountryCode = dialCode;
    },
  },
  computed: {
    ...mapGetters("i18N",["getLanguage"]),
    ...mapGetters("authfack", [
      "getPhoneDuplicatedCheck",
      "getEmailDuplicatedCheck",
    ]),
    ...mapGetters("userType", [
      "getTouchModeStatus",
      "getHostUserTypesExist",
      "getPreRegistrationData",
    ]),
    ...mapGetters("preRegistration", [
      "getJourneyFlowId",
      "getSelectedUserType",
      "getCompliance",
      "getVisitDate",
      "getVisitTime",
      "getSelectedArea",
      "getDifferentUserType",
      "getNotAllowedToRegister",
      "getVisitExists",
      "getUserEntity",
      "getFirstName",
      "getLastName",
      "getEmail",
      "getPhone",
      "getCompanyName",
      "getPhoneInput",
      "getUserCountryCode",
      "getHasVisitedPage",
      "getSections",
    ]),
    formatedVisitDate() {
      const date = new Date(this.getVisitDate);
      return date?.toISOString().split("T")[0];
    },
    formattedTime() {
      if (this.getVisitTime) {
        const visit_time = new Date(this.getVisitTime);
        return visit_time.toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        });
      } else {
        return null;
      }
    },
    disableSubmitBtn() {
      const {
        form: { first_name, last_name, email, phone, register_check },
      } = this;
      const checkEmailValidation = email;
      const checkPhoneValidation = phone;
      if (register_check) {
        return !(
          first_name &&
          last_name &&
          (checkEmailValidation || checkPhoneValidation)
        );
      } else {
        return !(first_name && last_name);
      }
    },
    hasAnyValidationErr() {
      return (this.form.email &&
      this.getEmailDuplicatedCheck &&
      !this.getEmailDuplicatedCheck.available
        ? true
        : false) ||
        (this.form.phone &&
          this.getPhoneDuplicatedCheck &&
          !this.getPhoneDuplicatedCheck.available)
        ? true
        : false;
    },
  },
  beforeMount() {
    console.log(this.getLanguage)
    this.savedLang = this.getLanguage;
    if (this.savedLang) {
      document.documentElement.dir = this.savedLang === 'ar' ? 'rtl' : 'ltr';
    } else this.setLanguageAction("en");
    
    const containerElement = document.getElementsByTagName("html")[0];
    containerElement?.setAttribute('lang', this.getLanguage);
    if (this.getHasVisitedPage) {
      this.form.first_name = this.getFirstName;
      this.form.last_name = this.getLastName;
      this.form.email = this.getEmail;
      this.form.phone = this.getPhoneInput;
      this.phone_input = this.getPhoneInput;
      this.userCountryCode = this.getUserCountryCode;
      // this.form.company_name = this.getCompanyName;
    } else if (
      this.$route.query.add_visitor &&
      !this.$route.query.comingFromPassport
    ) {
      this.selectRedirectLoader(true);
      this.getPreRegDetails({ visitUrl: this.$route.params.id }).then(
        async (res) => {
          console.log("res", res);
          if (
            (!res.data.data.visitMetadata.is_expired ||
              !JSON.parse(res.data.data.visitMetadata.is_expired)) &&
            (!res.data.data.visitMetadata.is_confirmed ||
              !JSON.parse(res.data.data.visitMetadata.is_confirmed))
          ) {
            this.form.first_name = this.getFirstName;
            this.form.last_name = this.getLastName;
            this.form.email = this.getEmail;
            // this.form.phone = this.getPhone;
            this.phone_input = this.getPhoneInput ? this.getPhoneInput : "";
            this.originalEmail = this.getEmail;
            this.originalPhoneInput = this.getPhoneInput
              ? this.getPhoneInput
              : "";
            // this.userCountryCode = this.getUserCountryCode;
            // this.form.company_name = this.getCompanyName;
            const selected_user_type = [];
            selected_user_type.push({
              name: res.data.data.userType,
              pre_registration_method: res.data.data.registrationMethod,
              id: res.data.data.user.user_type_id,
              // journey_flow_id: this.$route.query.journey_flow_id,
              // entity_id: this.$route.query.user_type_entity_id
            });
            this.selectUserType(selected_user_type);
            if (res.data.data.user.passport_id) {
              console.log("has no passporttt");
              if (this.$route.query.comingFromPassport) {
                this.setCommingFromLogin(true);
              } else {
                window.location.href =
                  process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT +
                  `/login?` +
                  `serverUrl=${res.data.data.serverFrontUrl}&` +
                  `add_visitor=${true}&visit_url=${this.$route.params.id}` +
                  (res.data.data.user.email
                    ? "&email=" + encodeURIComponent(res.data.data.user.email)
                    : "") +
                  (res.data.data.user.phone
                    ? "&phone=" + encodeURIComponent(res.data.data.user.phone)
                    : "");
                // this.selectRedirectLoader(false);
              }
            } else {
              let userExists = 1;
              if (this.phone_input || this.form.email) {
                // If either email or phone input is provided, check if the user exists
                const response = await usersService.checkIfUserExists(
                  this.form.email,
                  this.phone_input
                );
                const { data } = response; // Destructure data from the response
                userExists = !data; // Set userExists based on whether data is found
              }

              // Prepare payload for checking custom fields API
              const checkCustomFieldsApiPayload = {
                ...this.sectionPayload,
                phone: this.phone_input
                  ? encodeURIComponent(this.phone_input)
                  : "",
                email: this.form.email
                  ? encodeURIComponent(this.form.email)
                  : "",
                visit_date: this.getVisitDate
                  ? moment(new Date(this.getVisitDate)).format("YYYY-MM-DD")
                  : "",
                visit_time: this.getVisitTime
                  ? moment(this.getVisitTime).format("HH:mm:ss")
                  : "",
                expectedDateTime: res.data.data.expectedDateTime,
                user_type_id: selected_user_type[0].id,
                area_id: res.data.data.area.id,
                is_new_user: userExists ? 1 : 0,
              };

              // Fetch expected visit custom fields
              const { data: sections } =
                await usersService.getExpectedVisitCustomFields(
                  checkCustomFieldsApiPayload
                );

              // Update sections
              this.setSections(sections);
              this.$emit("updateShowSections", !!sections.length);

              await new Promise((resolve) =>
                setTimeout(() => {
                  resolve();
                }, 100)
              );
              this.selectRedirectLoader(false);
            }
          }
        }
      );
      // console.log('pers', this.$route.params.id, this.$route.query.add_visitor);
    }
  },
  created() {
    setTimeout(() => {
      console.log(this.getSelectedUserType);
      console.log(this.getSelectedArea);
    }, 6000);

    console.log("getVsitTime", this.getVisitTime);
  },
};
</script>
<style lang="scss">
.not-allowed-cursor {
  cursor: not-allowed;
}
.errorr-value {
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.25px;
  color: #f46a6a;
}
.err-wrapperr {
  text-align: start !important;
  margin-bottom: 14px !important;
  padding-inline-start: 21px;
}
#customized-check {
  .custom-checkbox .custom-control-label::before {
    border: 3px solid #000000 !important;
    border-radius: 3px !important;
    height: 17px !important;
    width: 17px !important;

    background-size: cover !important;
  }
  .custom-checkbox-dark
    .custom-control-input:checked
    ~ .custom-control-label:before {
    background: #000000;
    border-color: #000000;
  }
}

.login-container{
  display: flex; 
  justify-content: space-between; 
  margin: auto;
  width: fit-content;
}
</style>
<style lang="scss" scoped>

.change-text {
  width: 103px;
  height: 55px;
  background: #103f5e;
  border-radius: 4px;
  color: #ffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.m-d-gruop > .form-control:disabled ~ label {
  font-weight: 700 !important;
  font-size: 10px !important;
  line-height: 17px !important;
  letter-spacing: 0.25px !important;
  color: #103f5e !important;
  opacity: 0.3 !important;
}

input#phone:disabled,
input#email:disabled {
  font-weight: 600 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  letter-spacing: 0.25px !important;
  color: rgba(0, 0, 0, 0.87) !important;
  opacity: 0.3 !important;
}
input#email,
input#phone {
  background: #f2f2f2;
}
span.country-code {
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 17px !important;

  align-items: center;
  letter-spacing: 0.25px;

  color: #000000 !important;
}
span.dropdown-arrow {
  color: #000000 !important;
}
.m-d-gruop > label {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px !important;
  letter-spacing: 0.25px !important;
  color: rgba(96, 96, 96, 0.87);
  opacity: 0.8 !important;
}
.m-d-gruop > .form-control:valid ~ label,
.disable-label {
  font-weight: 700 !important;
  font-size: 10px !important;
  line-height: 17px !important;
  letter-spacing: 0.25px !important;
  color: #103f5e !important;
  bottom: 40px !important;
}
.m-d-gruop > .form-control:focus ~ label {
  font-weight: 700 !important;
  font-size: 10px !important;
  line-height: 17px !important;
  letter-spacing: 0.25px !important;
  color: #103f5e !important;
  bottom: 40px !important;
}

.m-d-gruop > input {
  top: 11px !important;
}
.register-email-phone .register-hint .hint-label {
  font-size: 12px;
  text-align: start;
  margin-inline-start: 10px;
  color: #000;
}
.visit-register {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  border-radius: 26px;
  width: 491px;
  margin-top: 62px;
  margin-bottom: 62px;
  text-align: center;
  background-color: #ffffff;
  .visit-register-header {
    .logo-2 {
      margin: auto;
      width: 116px;
      height: 22px;
      margin-top: 48px;
      margin-bottom: 24px;
      img {
        width: 86px;
        height: 16px;
      }
    }
    .form-title {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0.25px;
      margin-bottom: 28px;
      color: #000000;
    }
    .sub-title {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.25px;
      color: #666666;
      margin-bottom: 36px;
    }
    .login-btn {
      color: #103f5e !important;
      font-size: 14px !important;
      font-weight: 700 !important;
    }
  }
  .content {
    margin: 0 39px 0 38px;
    font-size: 16px;
    .first-last-name-wrapper {
      display: flex;
      .required-star {
        position: relative;
        .required {
          color: #e51414;
          position: absolute;
          inset-inline-end: 22px;
          top: 18px;
          z-index: 1000;
          font-size: 1.2rem;
        }
      }
      .first-name {
        margin-inline-end: 14px;
        width: 200px;
      }
      .last-name {
        width: 200px;
      }
    }
    .current-phone {
      margin-bottom: 36px;
      .phone-group {
        display: flex;
      }
      .country-code-input {
        margin-inline-end: 14px;
      }
    }
    .current-phone .phone-group .country-code-input {
      width: 106px;
      height: 55px;
      background-color: #f2f2f2;
      border-radius: 4px;
      border: none;
    }
    .passport-email-phone {
      margin-bottom: 32px;
    }
    .email-wrapper {
      .err-wrapper {
        margin-top: -9px;
        margin-bottom: 6px;
      }
    }
    .current-phone {
      .err-wrapper {
        margin-top: 3px;
        margin-bottom: 6px;
        margin-inline-start: -110px;
      }
    }
    .register-account-check-wrapper {
      display: flex;

      margin-inline-end: 27px;
      margin-inline-start: 27px;
      margin-bottom: 133px;
      .text {
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        letter-spacing: 0.25px;
        color: #666666;
        text-align: start;
        margin-inline-start: 16px;
      }
    }
  }
}
.generate-btn {
  display: block;
  width: 415px;
  height: 44px;
  margin: 0 auto 38px auto;
  border-radius: 22px;
  font-weight: 500;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  color: #ffffff;
  text-align: center;
}

@media (max-width: 992px) {
  span.dropdown-arrow {
    color: #000000 !important;
  }
  .m-d-gruop > label {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px !important;
    letter-spacing: 0.25px !important;
    color: rgba(96, 96, 96, 0.87);
    opacity: 0.8 !important;
  }
  .m-d-gruop > .form-control:valid ~ label,
  .disable-label {
    font-weight: 700 !important;
    font-size: 10px !important;
    line-height: 17px !important;
    letter-spacing: 0.25px !important;
    color: #103f5e !important;
    bottom: 40px !important;
  }
  .m-d-gruop > .form-control:focus ~ label {
    font-weight: 700 !important;
    font-size: 10px !important;
    line-height: 17px !important;
    letter-spacing: 0.25px !important;
    color: #103f5e !important;
    bottom: 40px !important;
  }
  .m-d-gruop > input {
    top: 11px !important;
  }
  .register-email-phone .register-hint .hint-label {
    font-size: 12px;
    text-align: start;
    margin-inline-start: 10px;
    color: #000;
  }
  .visit-register {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    border-radius: 0px;
    width: 360px;
    text-align: center;
    background-color: #ffffff;
    .visit-register-header {
      .logo-2 {
        margin: auto;
        width: 116px;
        height: 22px;
        margin-top: 37px;
        margin-bottom: 38px;
        img {
          width: 116px;
          height: 22px;
        }
      }
      .form-title {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        letter-spacing: 0.25px;
        margin-bottom: 6px;
        color: #000000;
      }
      .sub-title {
        font-weight: 400;
        font-size: 13px;
        line-height: 20px;
        letter-spacing: 0.25px;
        color: #666666;
        margin-bottom: 25px;
      }
      .login-btn {
        color: #103f5e !important;
        font-size: 14px !important;
        font-weight: 700 !important;
      }
    }
    .content {
      margin: 0 26px 0 26px;
      font-size: 16px;

      .first-last-name-wrapper {
        flex-wrap: wrap;
        .required-star {
          position: relative;
          .required {
            color: #e51414;
            position: absolute;
            inset-inline-end: 22px;
            top: 18px;
            z-index: 1000;
            font-size: 1.2rem;
          }
        }
        .first-name {
          margin-inline-end: 0px !important;
          width: 308px !important;
        }
        .last-name {
          width: 308px !important;
        }
      }
      .current-phone {
        margin-bottom: 36px;
        .phone-group {
          display: flex;
        }
        .country-code-input {
          margin-inline-end: 14px;
        }
      }
      .current-phone .phone-group .country-code-input {
        width: 103px;
        height: 55px;
        background-color: #f2f2f2;
        border-radius: 4px;
        border: none;
        span.country-code {
          font-weight: 400 !important;
          font-size: 12px !important;
          line-height: 17px !important;

          align-items: center;
          letter-spacing: 0.25px;

          color: #000000 !important;
        }
      }
      .passport-email-phone {
        margin-bottom: 32px;
      }
      .email-wrapper {
        .err-wrapper {
          margin-top: -9px;
          margin-bottom: 6px;
          margin-inline-start: -20px;
        }
      }
      .current-phone {
        .err-wrapper {
          margin-top: 3px;
          margin-bottom: 6px;
          margin-inline-start: -20px;
        }
      }
      .register-account-check-wrapper {
        display: flex;
        margin-inline-end: 20px;
        margin-inline-start: 20px;
        margin-bottom: 188px;
        .text {
          font-weight: 400;
          font-size: 13px;
          line-height: 20px;
          letter-spacing: 0.25px;
          color: #666666;
          text-align: start;
          margin-inline-start: 15px;
        }
      }
    }
  }
  .generate-btn {
    display: block;
    width: 309px;
    height: 37px;
    margin: 0 auto 28px auto;
    border-radius: 18.5px;
    font-weight: 500;
    font-size: 16px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.25px;
    text-transform: uppercase;
    color: #ffffff;
    text-align: center;
  }
}
</style>
